export default __webpack_public_path__ + "static/hero-blur-22a576b7bb309e43405f2e2724ac1e83.svg";